import { Tag, Tooltip } from 'antd';
import { ExperimentOutlined } from '@ant-design/icons';

import type { CleaningRequirement } from '../../interfaces/ProcessCatalog.Interface';

/**
 * The special cleaning a delivery will be gated on.
 *
 * Shown on the delivery board and inside the shipping form so the operator sees
 * it before filling in quantities, not only when the confirmation stops them.
 */
export default function CleaningRequirementTag({
	cleaning,
	style,
}: {
	cleaning: CleaningRequirement;
	style?: React.CSSProperties;
}) {
	return (
		<Tooltip
			title={
				cleaning.instructions ||
				'This job requires a non-standard cleaning before delivery.'
			}
		>
			<Tag icon={<ExperimentOutlined />} color="cyan" style={style}>
				Cleaning: {cleaning.name}
			</Tag>
		</Tooltip>
	);
}
